import { DeviceFragment, RoomQuery } from "../generated/graphql";
import { MODEL_IDS, PRODUCT_IDS } from "../Constants";
import { nameIsUnassigned } from "./stringUtils";

export const getMTRAppDeviceId = (
  room: RoomQuery["room"]
): undefined | string => {
  if (!room || !room.devices) {
    return undefined;
  }

  if (nameIsUnassigned(room.name)) {
    return undefined;
  }

  const device = room.devices.find(
    device => MODEL_IDS.MTR === device?.model?.id
  );

  return device?.id;
};

export const isMTRApp = (device: DeviceFragment): boolean => {
  // would prefer to check ModelId, but not universally available
  return PRODUCT_IDS.MTR === device?.product?.id.toLowerCase();
};
